export var componentsLocales = {
    cabinetSettings: 'Personal account Kontur',
    cabinetCertificates: 'Certificates',
    cabinetServices: 'Payment for services',
    logout: 'Logout',
};
